import { Metamodel } from 'app/model/base/model';
import { DelimitedTextDataset } from 'shell-models-lib';
import { FormatWriteSettings } from './format-write-settings';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.delimitedText.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(DelimitedTextDataset) }
})
export class DelimitedTextFormatWriteSettings extends FormatWriteSettings {
    public static readonly MODEL: IModel;
    public static readonly FILE_EXTENSION: IAttribute;
    public static readonly QUOTE_ALL_TEXT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'FILE_EXTENSION',
        display: stringResources.ModelName_FileExtension
    })
    public fileExtension?: string = '.txt';

    @Metamodel.attribute({
        templatable: true,
        association: 'QUOTE_ALL_TEXT',
        display: stringResources.ModelName_QuoteAll
    })
    public quoteAllText?: boolean = true;
}
